export default __webpack_public_path__ + "static/media/headerbackground.b3a6dbff.jpg";